import { combineReducers } from 'redux'
import { createActionThunk } from 'redux-thunk-actions'
import { handleActions } from 'redux-actions'
import { actions as toastr } from 'react-redux-toastr'
import _ from 'lodash'

import api from 'core/api'

const getType = type => `@payments/bilderlingspay/${type}`

export const createBilderlingspayPaymentThunk = createActionThunk(
  getType('ADD'),
  api('/payments/bilderlingspay', { method: 'POST' })
)

export const createBilderlingspayPayment = props => (dispatch, getState) =>
  dispatch(createBilderlingspayPaymentThunk(props))
    .then(({ json }) => {
      const form = document.createElement('form')
      form.method = 'POST'
      form.action = getState().parameters.json['bilderlingspay_direct_url']

      _.each(json, (value, name) => {
        const input = document.createElement('input')
        input.value = value
        input.name = name
        form.appendChild(input)
      })

      document.body.appendChild(form)
      form.submit()
    })
    .catch(res => {
      if (_.has(res, 'error.error.details') && _.isString(res.error.error.details)) {
        dispatch(toastr.add({ type: 'error', message: res.error.error.details }))
        throw res.error.error.details
      }
      if (_.has(res, 'error.error.type') && res.error.error.type === 'validation_error') {
        dispatch(toastr.add({ type: 'error', message: 'Validation error' }))
        throw res.error.error.details
      }
    })

const initialState = { loading: false }

const reducer = handleActions(
  {
    [createBilderlingspayPaymentThunk.START]: state => ({ ...state, loading: true }),
    [createBilderlingspayPaymentThunk.SUCCEEDED]: (state, { payload }) => ({
      ...state,
      ...payload
    }),
    [createBilderlingspayPaymentThunk.FAILED]: (state, { payload }) => ({ ...state, ...payload }),
    [createBilderlingspayPaymentThunk.ENDED]: state => ({ ...state, loading: false })
  },
  initialState
)

export default combineReducers({
  index: reducer
})



// WEBPACK FOOTER //
// ./src/modules/payments/bilderlingspay/index.js